import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'
import { Calendar } from 'lucide-react'

export default function DateRangeSelector({ 
  value, 
  onValueChange, 
  className = "w-[160px]",
  showIcon = true 
}) {
  return (
    <Select value={value} onValueChange={onValueChange}>
      <SelectTrigger className={className}>
        {showIcon && <Calendar className="h-4 w-4 mr-2" />}
        <SelectValue placeholder="Select period" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="1month">This Month</SelectItem>
        <SelectItem value="3months">Last 3 Months</SelectItem>
        <SelectItem value="6months">Last 6 Months</SelectItem>
        <SelectItem value="1year">Last Year</SelectItem>
        <SelectItem value="ytd">YTD</SelectItem>
        <SelectItem value="all">All Time</SelectItem>
      </SelectContent>
    </Select>
  )
}
